export const ReviewAction = {
  ACCEPT: 'accept',
  REJECT: 'reject',
};

export const REJECT_FEE_RECOMMENDATION_FORM_ID = 'reject-fee-recommendation-form';
export const FEE_RECOMMENDATION_REVIEW_NOTES_MAX_LENGTH = 500;
export const REJECT_ALL_DESCRIPTION = 'all pending recommendations in this submission';
